export const SUPPORT_EMAIL = 'support@amitable.ru'
